import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { reverseGeocodeLocationToAddress } from '@rsos/maps/interface/reverseGeocode/helpers';

/**
 * Adapted version of useReverseGeocode for form use
 * Returns the reverse geocoded address without storing in Redux
 */
const useFormReverseGeocode = ({ coordinates, service }) => {
  const [isReverseGeocoding, setIsReverseGeocoding] = useState(false);
  const [foundAddress, setFoundAddress] = useState(null);

  const gisGeocodeService = useSelector(
    state => state.gisServices.geocodeService,
  );

  const gisGeocodeServiceUrl = gisGeocodeService?.gis_service_url || null;
  const gisGeocodeServiceToken = gisGeocodeService?.token || null;

  // Reverse geocode coordinates to address
  useEffect(() => {
    if (!coordinates?.latitude || !coordinates?.longitude || !service) {
      return;
    }

    const location = {
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      onReverseGeocoding: setIsReverseGeocoding,
      service,
      serviceUrl: gisGeocodeServiceUrl,
      token: gisGeocodeServiceToken,
    };

    reverseGeocodeLocationToAddress(location)
      .then(response => {
        if (response) {
          setFoundAddress(response);
        } else {
          setFoundAddress(null);
        }
      })
      .catch(() => {
        setFoundAddress(null);
      });
  }, [coordinates, service, gisGeocodeServiceUrl, gisGeocodeServiceToken]);

  return {
    isReverseGeocoding,
    foundAddress,
  };
};

export default useFormReverseGeocode;
